import * as React from "react";
import { BalanceUpdatePurchaseDetailsFragmentFragment } from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";
import { Trans } from "react-i18next";

export const BalanceUpdatePurchaseDetails = ({
  details,
}: {
  details: BalanceUpdatePurchaseDetailsFragmentFragment;
}) => {
  return (
    <Trans i18nKey="transaction.BalanceUpdatePurchaseDetails_details">
      Purchased chip pack <strong>{{ name: details.name }}</strong>
    </Trans>
  );
};
